import "@capacitor/core"
import "./index.css"
import "~brandcss"

import AppLaunchSplash from "./AppLaunchSplash.vue"

const app = createApp(AppLaunchSplash)

app.mount("#splash")

export { app }
